import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PROYECTOS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function ProyectosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PROYECTOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
